import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

const screenSm = parseFloat(resolveConfig(tailwindConfig).theme.screens.sm);

const MODAL_CLASS_PREFIX = 'modal';
const PRELOAD_CLASS = 'sm:!opacity-5';

class RefreshOnResize {
    constructor() {
        this._run();
    }
    _run = () => {
        this._initWidth = document.body.clientWidth;

        addEventListener('resize', this._refreshOnResize);

        document.addEventListener('modalclosed', this._refreshOnResize);
    };
    _refreshOnResize = () => {
        if (this._initWidth !== document.body.clientWidth && !this._isFullscreen()) {
            if (!(this._initWidth < screenSm && document.body.clientWidth < screenSm)) {
                const isVideoModal = document.querySelector(`body[class*='${MODAL_CLASS_PREFIX}']`);

                if (!isVideoModal) {
                    document.body.classList.add(PRELOAD_CLASS);
                    location.reload();
                }
            }
        } else {
            this._initWidth = document.body.clientWidth;
        }
    };
    _isFullscreen() {
        return !!(document.fullscreenElement || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen);
    }
}

const refreshOnResize = new RefreshOnResize();
